import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { Dictionary } from "src/app/store/models/common_types";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { ReportingPagesService } from "../reporting-pages.service";
import { ReportingPagesDataService } from "../reporting-pages-data.service";
import { NzModalRef } from "ng-zorro-antd/modal";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { CommonModalService } from "src/app/shared/common-modal/common-modal.service";
import { CustomGridComponent } from "@va/core-library/custom-grid";
import {
  nextPageData,
  sortChange,
  filterData,
  reloadGrid,
  getHeight,
  searchedData,
} from "../util";

@Component({
  selector: "app-reporting-allcompanies",
  templateUrl: "./reporting-allcompanies.component.html",
  styleUrls: ["./reporting-allcompanies.component.scss"],
  host: { class: "allCompany-page-component" },
})
export class ReportingAllcompaniesComponent implements OnInit {
  showSearch = true;
  showGridFilters: boolean;
  page: string;
  columns: {
    columnFields: Array<Dictionary<any>>;
    columnsData: Array<Dictionary<any>>;
    widthConfig: Array<string>;
    setWidth?: boolean;
  };
  gridUrl: string;
  sortKey: string;
  exportKey: string;
  exportColumns: Array<any>;
  coveragestatusList: Array<any> = [];
  @ViewChild(CustomGridComponent)
  customGridComp: CustomGridComponent;
  globalSearchVal: string;
  dataCovegTypeId: number;
  modelOnlyComp: {
    show: boolean;
    value: boolean;
  };
  storeSub: Subscription;
  isSellside: boolean;
  isDataSet: boolean;
  totalResultCount: number;
  appliedFilter: {};
  sortObj: Dictionary<any>;
  sortOrder?: string = "desc";
  pageIndex = 1;
  pageSize = 24;
  pageSizeOptions = [12, 24, 48, 96];
  initialParams: {};
  dataObservable: Observable<any | any>;
  errorMsg = "Something went wrong!";
  isLoading = false;
  gridHeight;
  skeletonRows = 20;
  skeletonCol = 11;
  data: Array<any> = [];

  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private service: ReportingPagesService,
    private dataService: ReportingPagesDataService,
    private modalService: CommonModalService,
    private router: Router,
  ) {
    this.columns = {
      columnFields: [],
      columnsData: [],
      widthConfig: [],
      setWidth: true,
    };
    this.isDataSet = false;
    this.coveragestatusList = this.dataService.getCoverageStatusValue();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.page = "allcompany";
      this.gridUrl = "api/sectorindustrydata/?is_companypage=true&";
      const columnFields = [
        {
          field: "companyname",
          renderer: "link",
        },
        {
          field: "ticker",
          renderer: "link",
        },
        {
          field: "bloombergcode",
          renderer: "link",
        },
        {
          field: "country",
          renderer: null,
        },
        {
          field: "region",
          renderer: null,
        },
        {
          field: "sectorname",
          renderer: "link",
        },
        {
          field: "industryname",
          renderer: "link",
        },
        {
          field: "coveragestatus",
          renderer: null,
        },
        {
          field: "coveredsource",
          renderer: null,
        },
        {
          field: "companyinitiated",
          renderer: null,
        },
        {
          field: "lastreportingdate",
          renderer: null,
        },
      ];
      const columnsData = [
        [
          {
            children: 1,
            header: "Company",
            sortKey: "companyname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Ticker",
            sortKey: "ticker",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Bloomberg Ticker",
            sortKey: "bloombergcode",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Country",
            sortKey: "country",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Region",
            sortKey: "region",
            showSort: true,
            showFilter: false,
          },
          {
            children: 1,
            header: "Sector",
            sortKey: "sectorname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Industry",
            sortKey: "industryname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Coverage Status",
            sortKey: "coveragestatus",
            showSort: false,
            showFilter: true,
            filterType: "select",
            filterSelectValues: this.coveragestatusList,
            currentValue: "",
          },
          {
            children: 1,
            header: "Sources",
            sortKey: "coveredsource",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Initiation Date",
            sortKey: "companyinitiated",
            showSort: true,
            showFilter: false,
          },
          {
            children: 1,
            header: "Last revision date",
            sortKey: "lastreportingdate",
            showSort: true,
            showFilter: false,
          },
        ],
      ];
      const widthConfig = [
        "200px", //company
        "130px", //ticker
        "150px", //bloomber ticker
        "180px", //country
        "180px", //region
        "180px", //sector
        "180px", //industry
        "130px", //content type
        "110px", //sources
        "120px", // initial date
        "140px", // last rev date
      ];

      this.dataCovegTypeId =
        params.dataCovTypeId !== void 0 ? Number(params.dataCovTypeId) : 1;
      this.modelOnlyComp = {
        show: true,
        value: this.dataCovegTypeId === 1 ? true : false,
      };
      this.globalSearchVal = params.search !== void 0 ? params.search : "";

      this.sortKey = "coveredsource";
      this.columns.columnFields = columnFields;
      this.columns.columnsData = columnsData;
      this.columns.widthConfig = widthConfig;
      this.exportColumns = columnsData[0].map((d) => {
        return d.sortKey;
      });
      this.storeSub = this.store
        .select(stateGetter("globalHeader", "globalSettings"))
        .subscribe((data: any) => {
          if (Object.keys(data).length === 0 && data.constructor === Object) {
            return;
          }
          this.isSellside = data.isSellside;
          this.exportKey = data.isInternal ? "COMPANY_PAGE" : "";
          if (this.isSellside) {
            this.columns.columnFields.push({
              field: "views",
              renderer: "report-view-link",
            });
            this.columns.columnsData[0].push({
              children: 1,
              header: "Views",
              sortKey: "views",
              showSort: false,
              showFilter: false,
            });
            this.columns.widthConfig.push("280px");
          }
          this.isDataSet = true;
        });
    });
    this.service.logUserOnRedirection("ALL_COMPANY_PAGE", { VALUE: "" });
    this.totalResultCount = 0;
    this.appliedFilter = {};
    this.sortObj = {
      key: this.sortKey,
      value: this.sortOrder !== undefined ? this.sortOrder : "asc",
    };
    const params = {
      baseUrl: this.gridUrl,
      pageIndex: this.pageIndex,
      sortOrder: this.sortObj.value,
      sortKey: this.sortObj.key,
      pageSize: this.pageSize,
      page: this.page,
      filters: [],
      globalSearch: this.globalSearchVal,
    };
    if (this.dataCovegTypeId !== void 0) {
      params["dataCovTypeId"] = this.dataCovegTypeId;
    }
    this.initialParams = { ...params };
    this.dataObservable = this.dataService.getReportGridData(params);
  }

  onDataResolved(response) {
    if (response.status === "error") {
      this.totalResultCount = 0;
      if (response.not_entitled) {
        this.showDeleteAlertModal();
      }
    } else {
      this.data = response.rows.map((row) => {
        const rowObj = {
          companyname: {
            url: `/company/${row.ticker}`,
            displayText: row.companyname,
            name: row.companyname,
            tooltipText: "View Company Page",
          },
          ticker: {
            url: `/company/${row.ticker}`,
            displayText: row.ticker,
            name: row.ticker,
            tooltipText: "View Company Page",
          },
          bloombergcode: {
            url: `/company/${row.ticker}`,
            displayText: row.bloombergcode ? row.bloombergcode : "",
            name: row.bloombergcode,
            tooltipText: "View Company Page",
          },
          country: row.country,
          region: row.region,
          sectorname: {
            url: `/reporting/sector/${row.sectorname}`,
            displayText: row.sectorname,
            name: row.sectorname,
          },
          industryname: {
            url: "",
            displayText: row.industryname,
            name: row.industryname,
            clickCallback: () => {
              this.router.navigateByUrl(
                `/comparative-analysis/current?comp_type=industry&id=${row.industryid}&sub_id=-1`,
              );
            },
          },
          coveragestatus: row.coveragestatus,
          coveredsource: row.coveredsource,
          companyinitiated: row.companyinitiated,
          lastreportingdate: row.lastreportingdate,
          views: this.getViewsObj(row),
        };

        return rowObj;
      });
      this.totalResultCount = response.records;
    }
    this.gridHeight = getHeight.call(this);
  }

  toggleFilter(ev) {
    this.showGridFilters = ev.showFilters;
    this.gridHeight = getHeight.call(this);
  }

  onSearch(val) {
    this.data = [];
    searchedData.call(this, val);
  }

  onReloadGrid() {
    this.data = [];
    reloadGrid.call(this);
  }
  onModelCompanyValueChange(event) {
    this.dataCovegTypeId = event.modelCompanyValue === false ? 0 : 1;
  }

  getNextPageData([pageIndex, pageSize]) {
    this.data = [];
    nextPageData.call(this, pageIndex, pageSize);
  }

  onSortChange([sortData]) {
    this.data = [];
    sortChange.call(this, sortData);
  }

  filterApplied([value, columnData]) {
    this.data = [];
    filterData.call(this, value, columnData);
  }

  getViewsObj(row) {
    return {
      show: true,
      showAnalyst:
        row.show_sar &&
        (row.status === "Covered" || row.status === "In Progress"),
      analystLink: `/mex/${row.ticker}/SAR/${row.sar_tab}/${row.sar_source}`,
      analystIcon: row.show_as_reported,
      showDashboard: row.show_dashboard,
      companyLink: `/mex/${row.ticker}/NMV/${encodeURIComponent(row.nmv_tab)}`,
      dashboardLink: `/company/${row.ticker}/analystdashboard`,
    };
  }

  ngOnDestroy() {
    this.storeSub.unsubscribe();
  }

  handleFailure(err) {
    if (err && err[0] && err[0].not_entitled) {
      this.showDeleteAlertModal();
    }
  }

  showDeleteAlertModal = (): void => {
    const title = `Not Entitled`;
    const message = `<b>
        You are currently not entitled to this content.<br/>
      </b>
      Questions? Contact 
      <a href="mailto:support@visiblealpha.com">support@visiblealpha.com</a>
    `;

    let modal: NzModalRef = null;

    const primaryAction = () => {
      modal.close();
    };

    //configure modal to show alert message
    const modalOptions = {
      title: title,
      body: message,
      accentColor: "#ff4e33",
      icon: faExclamationTriangle as IconDefinition,
      actionPrimaryText: "Close",
      onPrimaryClick: primaryAction,
    };

    modal = this.modalService.create(modalOptions);

    modal.afterClose.subscribe(() => {
      this.router.navigateByUrl("/home");
    });
  };
}
